import React, { FC, ReactElement } from 'react'
import Button from '@/components/button'
import useWallet from '@/utils/hooks/useWallet'
import RuneCard from './rune-card'
import formatNumber from '@/utils/format-number'
import useRuneBalance from '@/utils/hooks/useRuneBalance'
import useRuneOutpoints from '@/utils/hooks/useRuneOutpoints'

const RuneList: FC<{
	onComplete: () => void
	setTab: (id: string) => void
	ticker: string
	balance: any
}> = (props): ReactElement => {
	const { ticker, setTab, onComplete, balance } = props
	// useWallet() kept for subscription side-effects.
	useWallet()

	const { data: runeData } = useRuneBalance()

	const selectedRune = React.useMemo(() => {
		const selectedRune = runeData.find((e) => e.ticker === ticker)
		return selectedRune
	}, [runeData, ticker])

	const { data: runeOutpoints } = useRuneOutpoints(
		selectedRune?.rune_id
	)
	const runes = runeOutpoints || []

	const renderRune = React.useCallback(
		(e: any, i: any) => {
			return (
				<RuneCard
					rune={e}
					onList={() => {}}
					onTransfer={() => {
						setTab('transfer')
					}}
					key={i}
					ticker={ticker}
					symbol={balance?.symbol}
					description={`${formatNumber(`${e?.amount}`)} ${balance?.symbol}`}
				></RuneCard>
			)
		},
		[ticker, balance?.symbol, setTab]
	)

	return (
		<>
			<p className="flex justify-center w-full text-base font-bold">Runes</p>
			{!!runes.length && (
				<div className="bg-card p-4 flex flex-col gap-4 rounded-xl border border-border">
					{runes.map(renderRune)}
				</div>
			)}
			<Button
				className="text-muted-foreground rounded-full text-base font-semibold p-0 h-12"
				onClick={onComplete}
			>
				Close
			</Button>
		</>
	)
}

export default RuneList
